import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "q-pa-md",
  style: {"background-color":"#F9F9F9"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DevAlert = _resolveComponent("DevAlert")!
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Snackbar = _resolveComponent("Snackbar")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_PrivacityNotice = _resolveComponent("PrivacityNotice")!
  const _component_ModalOnboarding = _resolveComponent("ModalOnboarding")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isDev)
      ? (_openBlock(), _createBlock(_component_DevAlert, {
          key: 0,
          ref: "devAlert"
        }, null, 512))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_layout, { view: "hHh LpR fff" }, {
        default: _withCtx(() => [
          _createVNode(_component_Navbar, {
            devAlertOffset: $setup.isDev ? $setup.offsetHeight : 0
          }, null, 8, ["devAlertOffset"]),
          ($setup.hideSidebar)
            ? (_openBlock(), _createBlock(_component_Sidebar, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_router_view),
          _createVNode(_component_Spinner),
          _createVNode(_component_Snackbar),
          _createVNode(_component_Footer),
          ($setup.showPrivacityDialog)
            ? (_openBlock(), _createBlock(_component_PrivacityNotice, { key: 1 }))
            : _createCommentVNode("", true),
          _createVNode(_component_ModalOnboarding)
        ]),
        _: 1
      })
    ])
  ], 64))
}